import type { AsyncItem } from 'owa-copilot-async-chat-types';

/**
 * The text identifying an async item across surfaces.
 *
 * While a turn is running the item shows the request that started it. Once the turn settles it
 * shows the generated title, falling back to the prompt and finally to the response preview --
 * items restored from the service carry no prompt, and a follow-up turn gets no generated title.
 */
export function getAsyncItemLabel(item: AsyncItem): string {
    if (item.status === 'Working' && item.prompt) {
        return item.prompt;
    }
    return item.title || item.prompt || item.responseSnippet;
}
